export const DEFAULT_COLORS = [
  '#008080',
  '#72B5A5',
  '#ABB1D3',
  '#5E6AAB',
  '#FFC84D',
  '#B27B00',
  '#80D1FF',
  '#0072B2',
  '#B4B7BB',
  '#84888D',
  '#D7B2B2',
  '#9A5151',
  '#CABF9B',
  '#8D7C4A',
  '#AECBD0',
  '#40676E',
  '#FFCF8A',
  '#EB8B00',
];
